import { StyleSheet } from 'react-native';
import { spacing, ticketColors, ticketFonts } from '../theme/public-api';

/**
 * Chrome compartido de headers de listados operativos (Catálogo / Inventario / Ventas…).
 * Desk = toolbar PC; KPI strip = métricas; mobile = grid + CTA gold + más.
 */
export const ticketOperationalHeader = StyleSheet.create({
  deskToolbar: {
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },
  deskActionRail: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flexShrink: 0,
  },
  deskSearchBox: {
    backgroundColor: ticketColors.paper,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    height: 40,
    minHeight: 40,
    paddingVertical: 0,
    paddingHorizontal: 12,
  },
  deskSearchInput: {
    fontSize: 14,
    fontWeight: '500',
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink,
    height: 40,
    paddingVertical: 0,
  },
  deskBtn: {
    height: 40,
    paddingHorizontal: 14,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deskBtnText: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  deskBtnGold: {
    height: 40,
    paddingHorizontal: 14,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
  },
  deskBtnGoldText: {
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.goldInk,
    fontFamily: ticketFonts.sans,
  },
  kpiStrip: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
  },
  kpiStripCell: {
    flex: 1,
    minWidth: 100,
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderRightWidth: 1,
    borderRightColor: ticketColors.ruleSoft,
  },
  kpiStripCellLast: {
    borderRightWidth: 0,
  },
  kpiStripNum: {
    fontSize: 18,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.4,
  },
  kpiStripLab: {
    marginTop: 4,
    fontSize: 10,
    fontWeight: '600',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  kpiStripNumWarn: {
    color: ticketColors.warn,
  },
  kpiStripNumOk: {
    color: ticketColors.ok,
  },
  kpiStripNumBad: {
    color: ticketColors.bad,
  },
  /** Separación del bloque header → listado (el botón Filtros ticket también aporta marginBottom). */
  headerMobile: {
    gap: 10,
    paddingBottom: spacing.sm,
  },
  kpiGridMobile: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
    backgroundColor: ticketColors.ruleSoft,
    marginBottom: 2,
  },
  kpiRowMobile: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  kpiCellMobile: {
    width: '33.333%',
    backgroundColor: ticketColors.paper,
    paddingVertical: 10,
    paddingHorizontal: 6,
    alignItems: 'center',
    gap: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  kpiNumMobile: {
    fontSize: 18,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.4,
    textAlign: 'center',
  },
  kpiLabelMobile: {
    fontSize: 10,
    fontWeight: '600',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    textAlign: 'center',
    fontFamily: ticketFonts.sans,
  },
  searchRowMobile: {
    flexDirection: 'row',
    gap: 8,
  },
  searchBoxMobile: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 12,
    height: 40,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  searchInputMobile: {
    flex: 1,
    fontSize: 14,
    fontWeight: '500',
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink,
    padding: 0,
  },
  actionsRowMobile: {
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
  },
  actionPrimaryMobile: {
    flex: 1,
    height: 44,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  actionPrimaryTextMobile: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.goldInk,
    fontFamily: ticketFonts.sans,
  },
  actionMoreMobile: {
    width: 44,
    height: 44,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  secLabelMobile: {
    marginTop: 4,
    marginHorizontal: 2,
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },

  // ── Soft KPI tiles (Square) ──────────────────────────────────────────────
  kpiSoftStrip: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: 8,
    padding: 12,
    backgroundColor: ticketColors.paper,
  },
  kpiSoftCell: {
    flex: 1,
    flexBasis: 0,
    minWidth: 0,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    paddingVertical: 12,
    paddingHorizontal: 12,
    gap: 4,
  },
  /** Selección gana sobre warn/bad (filtro activo). */
  kpiSoftCellSelected: {
    backgroundColor: ticketColors.brandSoft,
    borderColor: ticketColors.gold,
  },
  kpiSoftCellWarn: {
    backgroundColor: ticketColors.warnBg,
    borderColor: ticketColors.warnBorder,
  },
  kpiSoftCellBad: {
    backgroundColor: '#FEF2F2',
    borderColor: 'rgba(185,28,28,0.22)',
  },
  kpiSoftNum: {
    fontSize: 18,
    fontWeight: '800',
    color: ticketColors.ink,
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.4,
  },
  kpiSoftNumWarn: {
    color: ticketColors.warn,
  },
  kpiSoftNumBad: {
    color: ticketColors.bad,
  },
  kpiSoftLab: {
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  kpiSoftLabWarn: {
    color: ticketColors.warn,
  },
  kpiSoftLabBad: {
    color: ticketColors.bad,
  },
  kpiSoftGridMobile: {
    overflow: 'hidden',
    backgroundColor: ticketColors.paper,
  },
  kpiSoftRowMobile: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    padding: 12,
  },
  kpiSoftCellMobile: {
    backgroundColor: ticketColors.paper2,
    paddingVertical: 12,
    paddingHorizontal: 10,
    alignItems: 'flex-start',
    gap: 4,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    // Con gap 8 en row de 2 cols: ~50% rompe el wrap. flexBasis evita celdas deformes.
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
  },
  kpiSoftNumMobile: {
    fontSize: 18,
    fontWeight: '800',
    color: ticketColors.ink,
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.4,
  },
  // Valores largos ("Inactivo", "Pausada"): en web adjustsFontSizeToFit no achica —
  // el caller baja el fontSize para que no trunque en celdas de ~30%.
  kpiSoftNumMobileCompact: {
    fontSize: 15,
  },
  kpiSoftLabMobile: {
    fontSize: 10,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    fontFamily: ticketFonts.sans,
  },
});
